import { useEffect } from 'react';
import MetaLayout from 'components/templates/MetaLayout/MetaLayout';
import WebsiteLayout from 'components/templates/WebsiteLayout/WebsiteLayout';
import { getHashFromUrl } from 'functions/urlHelpers';
import { COOKIE_SECTION_ID } from 'consts/querySelectors';
import UpdateDate from 'components/atoms/UpdateDate/UpdateDate';
import PrivacyPageContent from 'components/organisms/PrivacyPageContent/PrivacyPageContent';
import { StyledTermsPrivacy } from 'components/atoms/SectionTermsPrivacy/SectionTermsPrivacy.style';
import StaticPageHero from 'components/molecules/StaticPageHero/StaticPageHero';
import { Container, StyledUpdateDate } from './PrivacyPage.style';

const PrivacyPage = () => {
  useEffect(() => {
    if (getHashFromUrl() !== COOKIE_SECTION_ID) return;

    const elem = document.getElementById(COOKIE_SECTION_ID);

    if (elem) elem.scrollIntoView();
  }, []);

  return (
    <MetaLayout title="Karma | Privacy">
      <WebsiteLayout>
        <StaticPageHero titleBanner="Privacy Notice" />
        <StyledTermsPrivacy>
          <Container>
            <StyledUpdateDate>
              <UpdateDate>September 2026</UpdateDate>
            </StyledUpdateDate>
            <PrivacyPageContent />
          </Container>
        </StyledTermsPrivacy>
      </WebsiteLayout>
    </MetaLayout>
  );
};

export default PrivacyPage;
